// yard/Yard3D.jsx - Main 3D Yard component combining canvas and HUD
import React from 'react';
import YardCanvas from './YardCanvas';
import YardHUD from './YardHUD';

const Yard3D = ({ deals = [], darkMode = false, onDogSelect }) => {
  return (
    <div style={{
      width: '100%',
      height: '100%',
      position: 'relative',
      borderRadius: 16,
      overflow: 'hidden',
    }}>
      {/* 3D Canvas */}
      <YardCanvas deals={deals} darkMode={darkMode} onDogSelect={onDogSelect} />

      {/* HUD Overlay */}
      <YardHUD darkMode={darkMode} deals={deals} />
    </div>
  );
};

export default Yard3D;
